import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const Svg5 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1Z M21.3327 8.248V11.392H13.7247L13.3647 16.696H13.5567C13.7807 16.168 14.0367 15.704 14.3247 15.304C14.6127 14.904 14.9807 14.592 15.4287 14.368C15.8767 14.144 16.4527 14.032 17.1567 14.032C18.1167 14.032 18.9807 14.248 19.7487 14.68C20.5327 15.096 21.1567 15.704 21.6207 16.504C22.0847 17.288 22.3167 18.24 22.3167 19.36C22.3167 20.496 22.0687 21.512 21.5727 22.408C21.0767 23.304 20.3487 24.008 19.3887 24.52C18.4287 25.032 17.2607 25.288 15.8847 25.288C14.8127 25.288 13.8927 25.144 13.1247 24.856C12.3567 24.552 11.7087 24.152 11.1807 23.656C10.6687 23.16 10.2447 22.632 9.90869 22.072L12.5247 20.008C12.8927 20.648 13.3327 21.2 13.8447 21.664C14.3567 22.128 15.0447 22.36 15.9087 22.36C16.7727 22.36 17.4207 22.112 17.8527 21.616C18.3007 21.12 18.5247 20.464 18.5247 19.648V19.456C18.5247 18.688 18.3007 18.08 17.8527 17.632C17.4047 17.184 16.7887 16.96 16.0047 16.96C15.3647 16.96 14.8287 17.096 14.3967 17.368C13.9647 17.624 13.6367 17.88 13.4127 18.136L10.4607 17.728L11.0847 8.248H21.3327Z",
		fill: "currentColor"
	})
});
export default Svg5;
